import React, { useEffect, useCallback, useState, useContext, useMemo } from 'react';
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Collapse } from 'reactstrap';
import navdata from "../LayoutMenuData";
import withRouter from "../../Components/Common/withRouter";
import { useSelector } from "react-redux";
import { createSelector } from 'reselect';
import MainContext from '../../Components/Contexts/MainContext'; // MainContext'i import ediyoruz
import { pageAccessGroupIdOf } from '../../Routes/pageAccess';
import { isStaffAccount } from '../../services/firmaSessionService';
import { getMyPermissions } from '../../services/rbacService';
// #325: the staff menu reads each item's route permission from the route table itself.
import { authProtectedRoutes } from '../../Routes/allRoutes';
import { usePortal } from '../../Components/Contexts/PortalContext';
// WAS (until #740): import { GECIT_ROLLERI } from '../../services/onayGecidi';
import { fuarKurallariGorunur } from '../../services/onayGecidi';
import { enAz, SEVIYE } from '../../services/portalService';
// #450: the "Organizatör" parent keeps only the entries the company's tiers open (pure, tested in organizatorMenu.test.js)
import { organizatorOgesi } from './organizatorMenu';
// #535: entries a set hides from the sidebar (Yabancı Katılımcı: "Required Documents")
import { setMenusundeGizli } from './setMenusu';
// #704: the simple panel's entries follow Sade panel modu too, not only the Yabancı Katılımcı set code
import { gorunumSetKodu } from '../../services/sadePanel';

// #311 (2026-10-11): which portal module each company menu item belongs to. A company login sees an item
// only when the ACTIVE interface set (GET /portal/context, header role switcher) reaches READ in it.
// null = always (home). Projeler is the decorator's project list: shown only in
// a Dekoratör set (a Katılımcı follows its project read-only on the stand page).
const PORTAL_MENU_MODULU = {
  FirmaAnaSayfa: null,
  FirmaKart: 'FIRMA_BELGELERI',
  FirmaStandlar: 'STANDLAR',
  FirmaTalepler: 'TALEPLER',
  FirmaProjeler: 'PROJELER',
  FirmaPersonel: 'PERSONEL',
  FirmaTaseronlar: 'TASERON',
  FirmaOrganizator: 'FIRMA_YONETIMI',
  FirmaKroki: 'KROKI', // #322: yalnızca organizatörün setinde READ
  FirmaBelgeGereksinimleri: 'BELGE_GEREKSINIMLERI',
  FirmaFuarKurallari: null, // #536: no module of its own; only in a Katılımcı or Dekoratör set (Yerli + Yabancı, #540), see portalModulu
};

const VerticalLayout = (props) => {
  const navData = navdata().props.children;
  const [userGroup, setUserGroup] = useState(null);
  const [loadingGroup, setLoadingGroup] = useState(true);

  // MainContext'ten getUserGroupContext fonksiyonunu çekiyoruz
  const { getUserGroupContext, api } = useContext(MainContext);
  // #311: null for staff.
  const portal = usePortal();

  useEffect(() => {
    const fetchUserGroup = async () => {
      try {
        const userId = localStorage.getItem('userId');
        const groupData = await getUserGroupContext(userId);
        if (groupData && (groupData.id || (groupData.userGroupEntity && groupData.userGroupEntity.id))) {
          // #302: the menu of the role whose pages this login gets (a new role: its template's).
          // WAS: const groupId = groupData.id || groupData.userGroupEntity.id;
          const groupId = pageAccessGroupIdOf(groupData);
          setUserGroup(groupId);
        } else {
          console.log("User Group ID not found in groupData");
        }
      } catch (error) {
        console.error('API Error:', error);
      } finally {
        setLoadingGroup(false);
      }
    };

    fetchUserGroup();
  }, [getUserGroupContext]);

  // #325 (2026-10-11): the STAFF menu follows the page permissions (GET /rbac/me), not a list per role id.
  // An item shows when the route it links to opens for this login (allRoutes.js `permission:`; root holds
  // every key); a "/#" parent shows when any of its children shows; a company-portal route (side "firma")
  // never shows to staff. MainContext's root list (api.groups[1]) stays only as the outer set of top-level
  // ids a staff menu may hold, so an id never meant for staff stays out. A new staff role thus
  // needs no code change. The company menu is unchanged (#311).
  // WAS (#160 / #309 / #302), the per-role filter this replaces:
  // // 2026-10-10 (backlog #160): role-gated SUB-items. MainContext lists 'PlanAyarlari' / 'YetkiYonetimi'
  // // (and now the e-mail pages) in some roles' visibleItems, but only TOP-level ids were ever filtered, so
  // // every role that sees Sistem Ayarları also saw those links and hit the route's role gate on click.
  // // Only the ids below are filtered; every other sub-item stays as it was.
  // // WAS (until #159): const GATED_SUB_ITEMS = ['PlanAyarlari', 'YetkiYonetimi', 'EmailHesaplari', 'EmailSablonlari', 'EmailKayitlari'];
  // // WAS (until #158): const GATED_SUB_ITEMS = ['PlanAyarlari', 'YetkiYonetimi', 'EmailHesaplari', 'EmailSablonlari', 'EmailKayitlari', 'FirmaTurleri'];
  // // WAS (until #162): const GATED_SUB_ITEMS = ['PlanAyarlari', 'YetkiYonetimi', 'EmailHesaplari', 'EmailSablonlari', 'EmailKayitlari', 'FirmaTurleri', 'DosyaTurleri'];
  // const GATED_SUB_ITEMS = ['PlanAyarlari', 'YetkiYonetimi', 'EmailHesaplari', 'EmailSablonlari', 'EmailKayitlari', 'FirmaTurleri', 'DosyaTurleri', 'DosyaAyarlari'];
  // // #309: sub-items shown by PERMISSION on top of the role's list (GET /rbac/me): Yetki Yönetimi for
  // // anyone holding rbac.manage, not only the root role. Root holds every key.
  // const PERMISSION_SUB_ITEMS = { YetkiYonetimi: 'rbac.manage' };
  // const [permissionKeys, setPermissionKeys] = useState(null);
  // // KURAL: fetch Effect içindeki async fonksiyonda (react-hooks/set-state-in-effect).
  // useEffect(() => {
  //   let ignore = false;
  //   async function run() {
  //     try {
  //       const me = await getMyPermissions();
  //       if (!ignore) setPermissionKeys(me?.root ? Object.values(PERMISSION_SUB_ITEMS) : (me?.permissions || []));
  //     } catch {
  //       if (!ignore) setPermissionKeys([]);
  //     }
  //   }
  //   if (localStorage.getItem('token')) run();
  //   return () => { ignore = true; };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  // const filterNavDataByConfig = (navData, userGroup) => {
  //   // WAS (until #307): const groupConfig = api.groups[userGroup] || api.groups.default; // Burada config yerine api.groups kullanıyoruz
  //   // #307: a company-side login (not staff by the backend's rule) always gets the company portal's menu.
  //   const groupConfig = isStaffAccount()
  //     ? (api.groups[userGroup] || api.groups.default)
  //     : api.groups.firma;
  //   if (groupConfig.visibleItems === '*') return navData;
  //   const allowed = (id) => groupConfig.visibleItems.includes(id)
  //     || (PERMISSION_SUB_ITEMS[id] && (permissionKeys || []).includes(PERMISSION_SUB_ITEMS[id]));
  //   // #311: a company login's items also follow the active interface set's modules. Until the portal
  //   // context arrives (or when it failed — PortalKapisi then shows the error) the candidates stay, minus
  //   // the organizer panel.
  //   const portalModulu = (id) => {
  //     if (isStaffAccount() || !(id in PORTAL_MENU_MODULU)) return true;
  //     const modul = PORTAL_MENU_MODULU[id];
  //     if (!portal?.aktif) return id !== 'FirmaOrganizator';
  //     if (modul === null) return true;
  //     if (id === 'FirmaProjeler' && portal.aktif.rol !== 'DEKORATOR') return false;
  //     return enAz(portal.seviye(modul), SEVIYE.READ);
  //   };
  //   // WAS (until 2026-10-10): return navData.filter(item => groupConfig.visibleItems.includes(item.id));
  //   // WAS (until #311): .filter(item => groupConfig.visibleItems.includes(item.id))
  //   return navData
  //     .filter(item => groupConfig.visibleItems.includes(item.id) && portalModulu(item.id))
  //     .map(item => (Array.isArray(item.subItems)
  //       ? {
  //           ...item,
  //           subItems: item.subItems.filter(
  //             // WAS (until #309): sub => !GATED_SUB_ITEMS.includes(sub.id) || groupConfig.visibleItems.includes(sub.id)),
  //             sub => !GATED_SUB_ITEMS.includes(sub.id) || allowed(sub.id)),
  //         }
  //       : item));
  // };

  // null until GET /rbac/me answers; then { root, permissions }.
  const [me, setMe] = useState(null);
  // KURAL: fetch Effect içindeki async fonksiyonda (react-hooks/set-state-in-effect).
  useEffect(() => {
    let ignore = false;
    async function run() {
      try {
        const cevap = await getMyPermissions();
        if (!ignore) setMe({ root: Boolean(cevap?.root), permissions: cevap?.permissions || [] });
      } catch {
        if (!ignore) setMe({ root: false, permissions: [] });
      }
    }
    if (localStorage.getItem('token')) run();
    return () => { ignore = true; };
  }, []);

  const rotalar = useMemo(
    () => new Map(authProtectedRoutes.map((r) => [String(r.path).toLowerCase(), r])),
    []);

  /** true / false for a link to a known route; null for "/#" (no page of its own). */
  const rotaAcik = (link) => {
    if (!link || link === '/#' || link === '#') return null;
    const rota = rotalar.get(String(link).toLowerCase());
    if (!rota) return true;                 // a link we do not route (legacy, external): as before
    if (rota.side === 'firma') return false;
    if (!rota.permission) return true;
    if (!me) return false;                  // hidden until /rbac/me answers
    return me.root || me.permissions.includes(rota.permission);
  };

  /** The item with only its visible children, or null when nothing in it opens. */
  const personelOgesi = (item) => {
    const kendi = rotaAcik(item.link);
    const altlar = ['subItems', 'childItems'].filter((k) => Array.isArray(item[k]));
    if (altlar.length === 0) return kendi === false ? null : item;
    const out = { ...item };
    let gorunen = 0;
    for (const k of altlar) {
      out[k] = item[k].map(personelOgesi).filter(Boolean);
      gorunen += out[k].length;
    }
    return gorunen === 0 && kendi !== true ? null : out;
  };

  // #311: a company login's items also follow the active interface set's modules. Until the portal
  // context arrives (or when it failed — PortalKapisi then shows the error) the candidates stay, minus
  // the organizer panel.
  const portalModulu = (id) => {
    // #535: the active set may hide an entry whose module it reaches (WAS: no such check)
    // WAS (until #704): if (setMenusundeGizli(id, portal?.aktif?.kod)) return false;
    if (setMenusundeGizli(id, gorunumSetKodu(portal))) return false;
    if (!(id in PORTAL_MENU_MODULU)) return true;
    const modul = PORTAL_MENU_MODULU[id];
    // WAS (until #536): if (!portal?.aktif) return id !== 'FirmaOrganizator';
    if (!portal?.aktif) return id !== 'FirmaOrganizator' && id !== 'FirmaFuarKurallari';
    // #536: the consent texts' preview is the exhibitor's page (WAS: no such check)
    // WAS (until #540): if (id === 'FirmaFuarKurallari' && portal.aktif.rol !== 'KATILIMCI') return false;
    // #540: Dekoratör logins are asked the same texts at login, so they can read them again here too
    // WAS (until #740): if (id === 'FirmaFuarKurallari' && !GECIT_ROLLERI.includes(portal.aktif.rol)) return false;
    // #740: the same criterion as the gate (one of the login's sets), not only the ACTIVE one
    if (id === 'FirmaFuarKurallari' && !fuarKurallariGorunur(portal)) return false;
    if (modul === null) return true;
    if (id === 'FirmaProjeler' && portal.aktif.rol !== 'DEKORATOR') return false;
    return enAz(portal.seviye(modul), SEVIYE.READ);
  };

  // eslint-disable-next-line no-unused-vars
  const filterNavDataByConfig = (navData, _userGroup) => {
    // WAS (until #411): if (!isStaffAccount()) {
    // #411: a staff login previewing a company's portal (read-only) gets that company's menu, from its interface set.
    if (!isStaffAccount() || portal?.onizleme) {
      const firmaConfig = api.groups.firma;
      if (firmaConfig.visibleItems === '*') return navData;
      // WAS (until #450): return navData.filter((item) => firmaConfig.visibleItems.includes(item.id) && portalModulu(item.id));
      return navData
        .filter((item) => firmaConfig.visibleItems.includes(item.id) && portalModulu(item.id))
        .map((item) => organizatorOgesi(item, portal))
        .filter(Boolean);
    }
    const ustSinir = api.groups[1]?.visibleItems || [];
    return navData
      .filter((item) => ustSinir === '*' || ustSinir.includes(item.id))
      .map(personelOgesi)
      .filter(Boolean);
  };


  const filteredNavData = filterNavDataByConfig(navData, userGroup);

  const selectLayoutState = (state) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout) => ({
      leftsidbarSizeType: layout.leftsidbarSizeType,
      sidebarVisibilitytype: layout.sidebarVisibilitytype,
      layoutType: layout.layoutType
    })
  );
  const {
    leftsidbarSizeType, sidebarVisibilitytype, layoutType
  } = useSelector(selectLayoutProperties);

  const resizeSidebarMenu = useCallback(() => {
    var windowSize = document.documentElement.clientWidth;
    if (windowSize >= 1025) {
      if (document.documentElement.getAttribute("data-layout") === "vertical") {
        document.documentElement.setAttribute("data-sidebar-size", leftsidbarSizeType);
      }
      if (document.documentElement.getAttribute("data-layout") === "semibox") {
        document.documentElement.setAttribute("data-sidebar-size", leftsidbarSizeType);
      }
      if ((sidebarVisibilitytype === "show" || layoutType === "vertical" || layoutType === "twocolumn") && document.querySelector(".hamburger-icon")) {
        var hamburgerIcon = document.querySelector(".hamburger-icon");
        if (hamburgerIcon !== null) {
          hamburgerIcon.classList.remove("open");
        }
      } else {
        var hamburgerIcon = document.querySelector(".hamburger-icon");
        if (hamburgerIcon !== null) {
          hamburgerIcon.classList.add("open");
        }
      }

    } else if (windowSize < 1025 && windowSize > 767) {
      document.body.classList.remove("twocolumn-panel");
      if (document.documentElement.getAttribute("data-layout") === "vertical") {
        document.documentElement.setAttribute("data-sidebar-size", "sm");
      }
      if (document.documentElement.getAttribute("data-layout") === "semibox") {
        document.documentElement.setAttribute("data-sidebar-size", "sm");
      }
      if (document.querySelector(".hamburger-icon")) {
        document.querySelector(".hamburger-icon").classList.add("open");
      }
    } else if (windowSize <= 767) {
      document.body.classList.remove("vertical-sidebar-enable");
      if (document.documentElement.getAttribute("data-layout") !== "horizontal") {
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
      if (document.querySelector(".hamburger-icon")) {
        document.querySelector(".hamburger-icon").classList.add("open");
      }
    }
  }, [leftsidbarSizeType, sidebarVisibilitytype, layoutType]);

  useEffect(() => {
    window.addEventListener("resize", resizeSidebarMenu, true);
  }, [resizeSidebarMenu]);

  const path = props.router.location.pathname;

  function activateParentDropdown(item) {
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

    if (parentCollapseDiv) {
      parentCollapseDiv.classList.add("show");
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse")) {
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").classList.add("show");
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").previousElementSibling.classList.add("active");
        }
      }
      return false;
    }
    return false;
  }

  const removeActivation = (items) => {
    let actiItems = items.filter((x) => x.classList.contains("active"));

    actiItems.forEach((item) => {
      if (item.classList.contains("menu-link")) {
        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const initMenu = () => {
      const pathName = process.env.PUBLIC_URL + path;
      const ul = document.getElementById("navbar-nav");
      const items = ul.getElementsByTagName("a");
      let itemsArray = [...items];
      removeActivation(itemsArray);
      let matchingMenuItem = itemsArray.find((x) => {
        return x.pathname === pathName;
      });
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    if (props.layoutType === "vertical") {
      initMenu();
    }
  }, [path, props.layoutType]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loadingGroup) {
    return <div>Loading...</div>;
  }

  return (
    <React.Fragment>
      {(filteredNavData || []).map((item, key) => {
        return (
          <React.Fragment key={key}>
            {item['isHeader'] ? (
              <li className="menu-title"><span data-key="t-menu">{(item.label)} </span></li>
            ) : (
              item.subItems ? (
                <li className="nav-item">
                  <Link
                    onClick={item.click}
                    className="nav-link menu-link"
                    to={item.link ? item.link : "/#"}
                    data-bs-toggle="collapse"
                  >
                    <i className={item.icon}></i>
                    <span data-key="t-apps">{(item.label)}</span>
                    {item.badgeName && (
                      <span className={"badge badge-pill bg-" + item.badgeColor} data-key="t-new">{item.badgeName}</span>
                    )}
                  </Link>
                  <Collapse
                    className="menu-dropdown"
                    isOpen={item.stateVariables}
                    id="sidebarApps">
                    <ul className="nav nav-sm flex-column test">
                      {item.subItems && (item.subItems || []).map((subItem, key) => (
                        <React.Fragment key={key}>
                          {!subItem.isChildItem ? (
                            <li className="nav-item">
                              <Link
                                onClick={subItem.click}
                                to={subItem.link ? subItem.link : "/#"}
                                className="nav-link"
                                data-bs-toggle={subItem.subItems ? "collapse" : undefined}
                                data-bs-target={subItem.subItems ? `#${subItem.id}` : undefined}
                              >
                                {(subItem.label)}
                                {subItem.badgeName && (
                                  <span className={"badge badge-pill bg-" + subItem.badgeColor} data-key="t-new">{subItem.badgeName}</span>
                                )}
                              </Link>
                              {subItem.subItems && (
                                <Collapse className="menu-dropdown" isOpen={subItem.stateVariables} id={subItem.id}>
                                  <ul className="nav nav-sm flex-column">
                                    {subItem.subItems.map((deepItem, key) => (
                                      <li className="nav-item" key={key}>
                                        <Link
                                          to={deepItem.link ? deepItem.link : "/#"}
                                          className="nav-link"
                                          onClick={deepItem.click}
                                        >
                                          {(deepItem.label)}
                                        </Link>
                                      </li>
                                    ))}
                                  </ul>
                                </Collapse>
                              )}
                            </li>
                          ) : (
                            <li className="nav-item">
                              <Link
                                onClick={subItem.click}
                                className="nav-link"
                                to="/#"
                                data-bs-toggle="collapse"
                                data-bs-target={`#${subItem.id}`}
                              >
                                {(subItem.label)}
                                {subItem.badgeName && (
                                  <span className={"badge badge-pill bg-" + subItem.badgeColor} data-key="t-new">{subItem.badgeName}</span>
                                )}
                              </Link>
                              <Collapse className="menu-dropdown" isOpen={subItem.stateVariables} id={subItem.id}>
                                <ul className="nav nav-sm flex-column">
                                  {subItem.childItems && (subItem.childItems || []).map((childItem, key) => (
                                    <React.Fragment key={key}>
                                      {!childItem.childItems ? (
                                        <li className="nav-item">
                                          <Link
                                            to={childItem.link ? childItem.link : "/#"}
                                            className="nav-link">
                                            {(childItem.label)}
                                          </Link>
                                        </li>
                                      ) : (
                                        <li className="nav-item">
                                          <Link to="/#" className="nav-link" onClick={childItem.click} data-bs-toggle="collapse" data-bs-target={`#${childItem.id}`}>
                                            {(childItem.label)}
                                          </Link>
                                          <Collapse className="menu-dropdown" isOpen={childItem.stateVariables} id={childItem.id}>
                                            <ul className="nav nav-sm flex-column">
                                              {childItem.childItems && childItem.childItems.map((subChildItem, key) => (
                                                <li className="nav-item" key={key}>
                                                  <Link to={subChildItem.link} className="nav-link" data-key="t-basic-action">{(subChildItem.label)} </Link>
                                                </li>
                                              ))}
                                            </ul>
                                          </Collapse>
                                        </li>
                                      )}
                                    </React.Fragment>
                                  ))}
                                </ul>
                              </Collapse>
                            </li>
                          )}
                        </React.Fragment>
                      ))}
                    </ul>
                  </Collapse>
                </li>
              ) : (
                <li className="nav-item">
                  <Link
                    className="nav-link menu-link"
                    to={item.link ? item.link : "/#"}>
                    <i className={item.icon}></i> <span>{(item.label)}</span>
                    {item.badgeName && (
                      <span className={"badge badge-pill bg-" + item.badgeColor} data-key="t-new">{item.badgeName}</span>
                    )}
                  </Link>
                </li>
              )
            )}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

VerticalLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter((VerticalLayout));
